import React from 'react'
import FormContacts from './FormContacts'
import '../../../styles/Contacts.css'

function Contacts() {
  return (
    <div id="Contacts" className="contacts">
      <div id="section-contacts" className="sectionContacts">
        <div id="container-texte-contacts" className="containerTexteContacts">
          <div id="block-text-contacts" className="blockText">
            <h3 className="subtitle">Contacts DUO DANSE.</h3>
            <br />
            <br />
            <p className="contactInfo">
              Christine: 06 61 62 01 05 <br />
              Pascal: 06 13 56 36 98 <br />
              Christophe: 06 63 53 04 74 <br />
              Audrey: 06 12 26 67 00 <br />
              Mail: duodanse@yahoo.fr
            </p>
          </div>
          <div id="carte" className="blocCarte">
            <iframe
              title="carte"
              id="carte-renney"
              className="carteRenney"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2825.563634517634!2d-0.63038498446096!3d44.91187227909826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd54d66fadf24a8b%3A0x6433f589e7b6fa3b!2sEcole%20El%C3%A9mentaire%20La%20Renney!5e0!3m2!1sfr!2sfr!4v1642871856158!5m2!1sfr!2sfr"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
      <div id="formulaire" className="containerFormulaire">
        <h1 className="title">
          Posez vos questions à l'aide de notre formulaire de contact.
        </h1>
        <FormContacts />
      </div>
    </div>
  )
}

export default Contacts
